/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require blueimp-file-upload/js/jquery.fileupload.js

window.FileUploads = {

  _refreshPage() {
    if (this.uploaded) {
      return location.reload();
    }
  },

  checkUploadState() {
    const uploadRowSet = $(".upload_files .uploadrow, .edit-uploadrow");
    const uploadRowsLength = uploadRowSet.length;
    const activeRowsLength = uploadRowSet.filter( function() {
      return $(this).data('active');
    }).length;
    if ((uploadRowsLength > this._minimumUploadRowsLength()) && !activeRowsLength) {
      return $('#start_uploads').removeClass('disabled').prop('disabled', false);
    } else {
      return $('#start_uploads').addClass('disabled').prop('disabled', true);
    }
  },

  _minimumUploadRowsLength() {
    if (this._isEditForm() || this._isEditWithIssuesForm() || !this._isSingleFileUploadForm()) { return 0; } else { return 1; }
  },

  _isEditForm() {
    return this.uploadForm.hasClass('edit');
  },

  _isAddRequiredDocumentForm() {
    return this.uploadForm.hasClass('required');
  },

  _isSingleFileUploadForm() {
    return this.uploadForm.hasClass('single_document_upload');
  },

  _isEditWithIssuesForm() {
    return this.uploadForm.hasClass('with_issues');
  },

  startUploads() {
    const $uploadRows = $('.upload_files .uploadrow, .upload_files .edit-uploadrow');
    $uploadRows.each(function() {
      const uploadRow = $(this);
      const rowCallBack = uploadRow.data('start_upload');
      if (jQuery.isFunction(rowCallBack)) {
        uploadRow.removeData('start_upload');
        uploadRow.data('active', true);
        return rowCallBack();
      }
    });
    if (this._shouldSubmitOnlyStaticFields($uploadRows.length)) {
      $('#static_fields').submit();
    }
    return this.checkUploadState();
  },

  _shouldSubmitOnlyStaticFields(uploadRowsLength){
    if (uploadRowsLength > 0) { return false; }
    if (this._isEditForm()) { return true; } else { return !this.uploaded; }
  },

  _initializeFileUploadUI() {
    this.uploaded = false;
    this.uploadTable = $('.upload_files');
    this.downloadTable = $('.download_files');

    const options = {
      autoUpload: false,
      dropZone: null,
      add: (e, data) => {
        const $uploadRow = $('#uploadrow_template').children().first().clone();
        if (this._isSingleFileUploadForm()) {
          this._removePreviousUploadRows();
        } else {
          const filePath = data.files[data.files.length - 1].name;
          this._setFilenameInUploadRow($uploadRow, filePath);
        }
        this.uploadTable.append($uploadRow);
        data.row = $uploadRow;
        $uploadRow.data('start_upload', data.submit.bind(data));
        $uploadRow.find('.file_upload_progress').append($('<progress value="0" max="1"></progress>'));
        $uploadRow.find('.file_upload_cancel').click(() => {
          $uploadRow.remove();
          return this.checkUploadState();
        });
        return this.checkUploadState();
      },
      progress: (e, data) => {
        return data.form.parent().find('progress').prop('value', data.loaded).prop('max', data.total);
      },
      fail: (e, data) => {
        this.checkUploadState();
        return $('<p data-abide="" class="alert-box relative error top-buffer"><span class="error">Connection error, please try again later</span> <a class="close"><i class="pti pt-cancel"></i></a></p>')
          .appendTo(this.downloadTable).fadeIn();
      },
      done: (e, data) => {
        const xhr = data.jqXHR;
        const JSONresponse = xhr.responseJSON;
        if ((xhr.status >= 200) && (xhr.status < 300)) {
          if (data.result.status !== 'unprocessable_entity') { this.uploaded = true; }
          if (this._isAddRequiredDocumentForm()) {
            this._setupUpdateForm(data.result);
            this.uploadForm.removeClass('required');
          } else if (this._isEditWithIssuesForm()) {
            window.location.replace(JSONresponse.redirect_url);
          }
        }

        this._removePreviousUploadRows();
        if (JSONresponse.status === 'created') {
          rudderanalytics.track('Document Created');
          $('<p class="alert-box relative success small-top-buffer">' + JSONresponse.message + ' <a class="close"><i class="pti pt-cancel"></i></a></p>')
            .hide().appendTo(this.downloadTable).fadeIn();
        } else {
          $('<p data-abide="" class="alert-box relative error small-top-buffer"><i class="far fas-exclamation-circle"></i>' + JSONresponse.message + ' <a class="close"><i class="fal fas-times"></i></a></p>')
            .hide().appendTo(this.downloadTable).fadeIn();
        }
        return this.checkUploadState();
      },
      submit: (e, data) => {
        const formData = Object.create(null);
        const inputs = $('#static_fields').add(data.row).find('input, select, textarea').filter(function() {
          const thisElem = $(this);
          return (thisElem.attr('type') !== 'radio') || thisElem.attr('checked');
        });
        inputs.each(function() {
          const thisElem = $(this);
          return formData[thisElem.attr('name')] = thisElem.val();
        });
        return data.formData = formData;
      }
    };

    this._setUploadMethod(options);
    return this.uploadForm.fileupload(options);
  },

  _setUploadMethod(options) {
    const formMethodInput = this.uploadForm.find("input[name='_method']");
    let method = formMethodInput.val();
    if (method && (method === 'patch')) { method = 'put'; }
    if (formMethodInput.length) { return options.type = method; }
  },

  _setupUpdateForm(JSONresponse) {
    const updateUrl = JSONresponse.update_url;
    const isPhase = JSONresponse.is_phase;

    // fileupload.js uses form's action to determine ajax calls url
    this._changeFormsActions(updateUrl);

    if (isPhase) {
      return this._updateInputsNamesForPhase();
    } else {
      return this._updateInputsNamesForTender();
    }
  },

  _changeFormsActions(url) {
    return $('.upload, #static_fields').prop('action', url);
  },

  _updateInputsNamesForPhase() {
    $("[name='document[documenter_note]']").prop('name', "note");
    return $("[name='document[doc]']").prop('name', "document_version[doc]");
  },

  _updateInputsNamesForTender() {
    return $("[name='bidder_document[doc]']").prop('name', "bidder_document[document]");
  },

  _setFilenameInUploadRow(uploadRow, filePath) {
    const fileName = this._extractFilenameFromPath(filePath);
    $('input.file_upload_name', uploadRow).val(fileName);
    return $('span.original_name', uploadRow).text(fileName);
  },

  _extractFilenameFromPath(filePath) {
    return filePath.replace(/^.*[\\\/]/, '').split('.')[0];
  },

  _getFilename(filename) {
    let extensionRegex;
    return extensionRegex = /(.*)\.[^.]*$/;
  },

  _removePreviousUploadRows() {
    const uploadRowSet = $(".upload_files .uploadrow, .edit-uploadrow");
    const uploadRowsLength = uploadRowSet.length;
    if (uploadRowsLength > 0) {
      const nonTempalteRows = uploadRowSet.filter( function() { return $(this).parent('#uploadrow_template').length === 0;  });
      return $(nonTempalteRows).remove();
    }
  },

  _initialize() {
    this.uploadForm = $('.upload');
    if (!this.uploadForm.hasClass('file_upload')) {
      this._initializeFileUploadUI();
    }
    return $(document).on('close.fndtn.reveal', '[data-reveal]', _.bind(this._refreshPage, this));
  },

  initializeWithValidation() {
    this._initialize();
    $(document).foundation({
      abide: {
        live_validate: false,
        validate_on_blur: false,
        validators: {
          filePresence(el, required, parent) {
            const uploadRowsLength = $(".edit-uploadrow").length;
            if (uploadRowsLength > 1) {
              $(el).parent().find('label .button').removeClass('missing-required-file');
              return true;
            } else {
              $(el).parent().find('label .button').addClass('missing-required-file');
              return false;
            }
          }
        }
      }
    });

    return $('#start_uploads').click(_.bind(this._startUploadsWithValidation, this));
  },

  _startUploadsWithValidation(event) {
    this._triggerFormValidation();
    const $errorsPresent = !!$('small.error:visible').length;
    if ($errorsPresent) {
      event.preventDefault();
      return;
    } else {
      return this.startUploads();
    }
  },

  _triggerFormValidation() {
    return Foundation.libs.abide.validate($('#edit_document, #static_fields').find('input, select, textarea'), {type:''});
  },

  basicInitialize() {
    this._initialize();
    return $('#start_uploads').click(_.bind(this.startUploads, this));
  },

  disableStaticFieldsValidation() {
    return $('#static_fields').removeAttr('data-abide', true).removeAttr('novalidate', true);
  }
};
